import { Link } from "react-router-dom";
import { faqs, packages } from "../../data/packages";
import { seo } from "../../data/site";
import { useDocumentMeta } from "../../hooks/useDocumentMeta";

export function PricingPage() {
  useDocumentMeta(seo.packages);
  return (
    <section className="section pricing-page page-view">
      <div className="section-kicker">Packages and Pricing</div>
      <div className="section-heading"><h1>Choose the right publicity package for your book's next stage.</h1><p>Compare clear campaign options for author visibility. Each package is scoped around outcomes, not confusing task lists, and final pricing is tailored after reviewing your book and goals.</p></div>
      <div className="pricing-grid">
        {packages.map((item) => <article className={`pricing-card ${item.featured ? "featured" : ""}`} key={item.name}>
          {item.featured && <span className="package-badge">Recommended</span>}
          <p>{item.audience}</p><h3>{item.name}</h3><div className="price-line"><strong>{item.price}</strong><span>{item.cadence}</span></div><p className="package-description">{item.description}</p>
          <div className="package-block"><h4>Best for</h4>{item.outcomes.map((outcome) => <span key={outcome}>{outcome}</span>)}</div>
          <div className="package-block"><h4>Included</h4>{item.includes.map((include) => <span key={include}>{include}</span>)}</div>
          <Link className={item.featured ? "primary-action package-action" : "secondary-action package-action"} to="/contact">Request Pricing</Link>
        </article>)}
      </div>
      <div className="faq-grid">{faqs.map((faq) => <article className="faq-card" key={faq.question}><h3>{faq.question}</h3><p>{faq.answer}</p></article>)}</div>
    </section>
  );
}
